import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { IDriverNobatQueueInfo } from "../../types/driver";
import { ITicket } from "../../types/ticket";

interface IUserType {
  fullName: string | null;
  smartCard: string | null;
  mobileNr: string | null;
  nationalCode: string | null;
  endDateHealthCard: string | null;
  ticketDetail: ITicket | null;

  isConfirm: boolean | null;

  licenseNumber?: string;

  birthDate?: {
    year: string;
    month: string;
    day: string;
  };

  stock?: number;

  phoneValid?: boolean;

  bankAccountInfo?: {
    shNr?: string;
    accountNr?: string;
    cardNr?: string;
    bankName?: string;
  };

  accomodationInfo?: {
    postalCode?: string;
    address?: string;
    cityInfo?: {
      cityCode?: number;
      cityName?: string;
    };
  };

  driverNobatQueueInfo: IDriverNobatQueueInfo;

  vehicleInfo: {
    loaderTypeGroup?: string;
    loaderTypeName?: string;
    endDateTechnicalExamination?: string;
    smartCard?: string;
    licensePlate?: {
      firstTowDigits?: string;
      lastThiredDigits?: string;
      alpha?: string;
      // licensePlateCityName: string;
      licensePlateSerial?: string;
    };
  };

  driverAttachs?: {
    driverAttach1: string;
    driverAttach2: string;
    driverAttach3: string;
    driverAttach4: string;
  };
}

const initialState: IUserType = {
  fullName: null,
  smartCard: null,
  mobileNr: null,
  nationalCode: null,
  endDateHealthCard: null,
  ticketDetail: null,
  isConfirm: false,

  vehicleInfo: {},

  driverNobatQueueInfo: {
    nobatCode: 0,
    nobatDate: null,
    salonInfo: null,
  },

  accomodationInfo: {},
};

export const userSlice = createSlice({
  name: "user",
  initialState,

  reducers: {
    setFullName: (state, action: PayloadAction<string | null>) => {
      state.fullName = action.payload;
    },
    setUserConfirm: (state, action: PayloadAction<boolean | null>) => {
      state.isConfirm = action.payload;
    },
    setSmartCart: (state, action: PayloadAction<string | null>) => {
      state.smartCard = action.payload;
    },
    setMobileNr: (state, action: PayloadAction<string | null>) => {
      state.mobileNr = action.payload;
    },
    setNationalCode: (state, action: PayloadAction<string | null>) => {
      state.nationalCode = action.payload;
    },
    setloaderTypeGroup: (state, action: PayloadAction<string>) => {
      state.vehicleInfo = {
        ...state.vehicleInfo,
        loaderTypeGroup: action.payload,
      };
    },

    setTicketDetail: (state, action: PayloadAction<ITicket | null>) => {
      state.ticketDetail = action.payload;
    },
    setPhoneValid: (state, action: PayloadAction<boolean>) => {
      state.phoneValid = action.payload;
    },

    setloaderGroup: (state, action: PayloadAction<string>) => {
      state.vehicleInfo.loaderTypeGroup = action.payload;
    },

    setloaderTypeName: (state, action: PayloadAction<string>) => {
      state.vehicleInfo.loaderTypeName = action.payload;
    },
    setVehicleSmartCard: (state, action: PayloadAction<string>) => {
      state.vehicleInfo.smartCard = action.payload;
    },

    setDriverLicensePlate: (
      state,
      action: PayloadAction<{
        alpha: string;
        firstTowDigits: string;
        lastThiredDigits: string;
        licensePlateSerial: string;
      }>
    ) => {
      state.vehicleInfo.licensePlate = action.payload;
    },

    setDriverNobatQueueInfo: (
      state,
      action: PayloadAction<IDriverNobatQueueInfo>
    ) => {
      state.driverNobatQueueInfo = action.payload;
    },

    setQueueCount: (state, action: PayloadAction<number>) => {
      state.driverNobatQueueInfo = {
        ...state.driverNobatQueueInfo,
        queueCount: action.payload,
      };
    },

    setBankAccountInfo: (
      state,
      action: PayloadAction<{
        accountNr?: string;
        cardNr?: string;
        shNr?: string;
        bankName?: string;
      }>
    ) => {
      state.bankAccountInfo = action.payload;
    },

    setAccomodationInfo: (
      state,
      action: PayloadAction<{
        postalCode?: string;
        address?: string;
        cityInfo?: {
          cityCode?: number;
          cityName?: string;
        };
      }>
    ) => {
      state.accomodationInfo = action.payload;
    },

    setAttachFiles: (
      state,
      action: PayloadAction<{
        driverAttach1: string;
        driverAttach2: string;
        driverAttach3: string;
        driverAttach4: string;
      }>
    ) => {
      state.driverAttachs = action.payload;
    },
    setUserStock: (state, action: PayloadAction<number>) => {
      state.stock = action.payload;
    },

    setBirthDate: (
      state,
      action: PayloadAction<{
        year: string;
        month: string;
        day: string;
      }>
    ) => {
      state.birthDate = action.payload;
    },

    setlicenseNumber: (state, action: PayloadAction<string>) => {
      state.licenseNumber = action.payload;
    },
  },
});

export const getUserState = (state: RootState) => state.user;

export const {
  setFullName,
  setUserConfirm,
  setSmartCart,
  setMobileNr,
  setPhoneValid,
  setNationalCode,
  setTicketDetail,
  setloaderTypeGroup,
  setloaderTypeName,
  setVehicleSmartCard,
  setDriverLicensePlate,
  setDriverNobatQueueInfo,
  setQueueCount,
  setBankAccountInfo,
  setAccomodationInfo,
  setAttachFiles,
  setUserStock,
  setBirthDate,
  setlicenseNumber,
} = userSlice.actions;

export default userSlice.reducer;
